<div class="modal-header">
  <h4 class="modal-title">Edit Text</h4>
  <button type="button" class="custom-close-btn" (click)="onCancel()" aria-label="Close">
    <img src="assets/icons/close-icon.svg" alt="close">
  </button>
</div>

<div class="modal-body">
  <div class="form-group">
    <label for="heading" class="form-label">Heading</label>
    <div class="heading-display">
      {{editedHeading}}
    </div>
    <input
      type="hidden"
      [(ngModel)]="editedHeading"
    />
  </div>

  <div class="form-group">
    <label for="text" class="form-label">Text</label>
    <textarea
      id="text"
      class="form-control textarea-control"
      [(ngModel)]="editedText"
      placeholder="Edit text"
      rows="6"
    ></textarea>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-cancel" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-save" (click)="onSave()" [disabled]="!editedHeading.trim() || !editedText.trim()">Save</button>
</div>


